/* eslint-disable @typescript-eslint/naming-convention */
export const FLOWWWME_STATUS = {
    OBSOLETE: 'OBSOLETE'
};

export const ERROR_CODES = {
    ERROR_NONE: 0,
    ERROR_SESSION_EXPIRED: 1,
    ERROR_SESSION_SPOOFED: 5,
    ERROR_SESSION_MULTIPLE: 261,
    ERROR_LOGIN: 3,
    ERROR_LOGIN_WHITE_IP: 334,
    ERROR_LOGIN_MAINTENANCE: 86,
    ERROR_SYSTEM_TRUNCATED: 398,
    ERROR_CONFIG_CLI_SEL: 80,
    ERROR_USER_OVERLAPPED: 158,
    ERROR_PROFESSIONAL_VISUAL: 448,
    ERROR_CLINICS_NOT_AVAILABLE: 596,
    ERROR_OTP: 622,
};

export const DEF_NUMBER_OF_CLIENT_CUSTOM_FIELDS = 10;

export const UNKNOWN_LABEL = '(ERR_LABEL_###_UNKNOWN)';
export const ERROR_CALL_MAPPER = '(ERR_CALL_MAPPER)';
export const ERROR_CALL_DATA = '(ERR_CALL_DATA)';

export const AES_URL_STORAGE_KEY = 'AES_URL';
export const SESSION_STORAGE_KEY = 'SessionID';
export const USERNAME_STORAGE_KEY = 'UserEmail';
export const PASSWORD_STORAGE_KEY = 'UserPassword';
export const AGENDA_DISPLAY_STORAGE_KEY = 'AgendaDisplay';

export const OTP_HASH_KEY = 'OtpHash';
export const OTP_HASH_DATE = 'OtpHashDate';

export const AGENDA_DATE_FORMAT = 'dddd LL';
export const FLOW_DATE_FORMAT = 'DD/MM/YYYY';
export const FLOW_TIME_FORMAT = 'HH:mm';

export const AES_KEY = 'Zq4t7w!z%C&F)J@N';

export const ICON_LIBRARY = {
    IONIC: 'ionic',
    DESIGN_SYSTEM: 'design-system'
};

export const INFORMATION_MODAL_SECTIONS = {
    SUCCESS_SIGN: 'successSign'
};
